import './TrustCredibility.css'

const trustSignals = [
  {
    title: 'Reliable Infrastructure',
    description: "Redundant systems, automated failovers, and 24/7 monitoring. Your business operations don't stop because we had a bad deploy.",
    stat: '99.9%',
    statLabel: 'Uptime SLA',
  },
  {
    title: 'Security Standards',
    description: 'Data encryption at rest and in transit. Regular security audits. Compliance with industry-standard practices.',
    stat: 'SOC 2',
    statLabel: 'Compliant',
  },
  {
    title: 'Transparent Pricing',
    description: "No hidden fees. No bait-and-switch. You see what you'll pay before you commit.",
    stat: '0',
    statLabel: 'Hidden fees',
  },
  {
    title: 'Real Support',
    description: 'When you need help, you talk to people who understand the product — not a chatbot reading scripts.',
    stat: '<2hr',
    statLabel: 'Response time',
  },
]

function TrustCredibility() {
  return (
    <section className="trust-credibility section">
      <div className="container">
        <div className="trust-header">
          <span className="section-label">Why Hubthrill</span>
          <h2 className="section-title">
            Built for businesses that<br />
            <span className="gradient-text">can't afford downtime.</span>
          </h2>
        </div>
        
        <div className="trust-intro">
          <p>
            Hubthrill is not a side project. Our modules — Chekkouts, Keeply, and 
            Namelyft — are production systems trusted by businesses processing real 
            transactions, managing real finances, and running real applications.
          </p>
          <p className="intro-emphasis">
            We don't move fast and break things. We move deliberately and build 
            things that last.
          </p>
        </div>

        <div className="trust-grid">
          {trustSignals.map((signal, index) => (
            <div key={index} className="trust-card">
              <div className="trust-stat">
                <span className="stat-value">{signal.stat}</span>
                <span className="stat-label">{signal.statLabel}</span>
              </div>
              <h3 className="trust-title">{signal.title}</h3>
              <p className="trust-description">{signal.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TrustCredibility
